const Parser = {
  phone: (value) => {
    // Remove todos os caracteres não numéricos, exceto o prefixo +55
    const phoneNumber = value.replace(/[^\d]/g, "").slice(2);

    // Adiciona o código de país +55 e formata conforme a máscara desejada
    const match = phoneNumber.match(/^(\d{2})(\d{1})(\d{4})(\d{4})$/);

    if (match) {
      return `+55 (${match[1]}) ${match[2]} ${match[3]}-${match[4]}`;
    } else if (phoneNumber.length <= 2) {
      return `+55 (${phoneNumber}`;
    } else if (phoneNumber.length <= 3) {
      return `+55 (${phoneNumber.slice(0, 2)}) ${phoneNumber.slice(2)}`;
    } else if (phoneNumber.length <= 7) {
      return `+55 (${phoneNumber.slice(0, 2)}) ${phoneNumber.slice(
        2,
        3
      )} ${phoneNumber.slice(3)}`;
    } else {
      return `+55 (${phoneNumber.slice(0, 2)}) ${phoneNumber.slice(
        2,
        3
      )} ${phoneNumber.slice(3, 7)}-${phoneNumber.slice(7, 11)}`;
    }
  },

  cpf(value) {
    if (!value) return value;
    const digits = value.replace(/\D/g, "").slice(0, 11);

    if (digits.length <= 3) {
      return digits;
    } else if (digits.length <= 6) {
      return `${digits.slice(0, 3)}.${digits.slice(3)}`;
    } else if (digits.length <= 9) {
      return `${digits.slice(0, 3)}.${digits.slice(3, 6)}.${digits.slice(6)}`;
    } else {
      return `${digits.slice(0, 3)}.${digits.slice(3, 6)}.${digits.slice(6, 9)}-${digits.slice(9)}`;
    }
  },

  cnpj(value) {
    if (!value) return value;
    const digits = value.replace(/\D/g, "").slice(0, 14);

    if (digits.length <= 2) {
      return digits;
    } else if (digits.length <= 5) {
      return `${digits.slice(0, 2)}.${digits.slice(2)}`;
    } else if (digits.length <= 8) {
      return `${digits.slice(0, 2)}.${digits.slice(2, 5)}.${digits.slice(5)}`;
    } else if (digits.length <= 12) {
      return `${digits.slice(0, 2)}.${digits.slice(2, 5)}.${digits.slice(5, 8)}/${digits.slice(8)}`;
    } else {
      return `${digits.slice(0, 2)}.${digits.slice(2, 5)}.${digits.slice(5, 8)}/${digits.slice(8, 12)}-${digits.slice(12)}`;
    }
  },

  email(value) {
    if (!value) return value;
    // Just return lowercase email as-is
    return value.toLowerCase().trim();
  },

  number(value) {
    if (value < 10000) {
      return value.toLocaleString("pt-BR");
    } else if (value < 1000000) {
      const truncated = Math.floor(value / 100) / 10; // ex: 953256 -> 9532.56 -> 953.2
      return `${truncated.toString().replace(".", ",")}k`.replace(",", ".");
    } else {
      const truncated = Math.floor(value / 10000) / 100; // ex: 1789502 -> 17895.02 -> 1.78
      return `${truncated.toString().replace(".", ",")}M`.replace(",", ".");
    }
  },

  date: {
    ddmmyyyy: (value) => {
      return value.split("-").reverse().join("/");
    },
    readable: (value) => {
      if (!value) return '';
      const date = new Date(value);
      return date.toLocaleDateString('pt-BR', {
        day: 'numeric',
        month: 'short',
        year: 'numeric'
      }) + ' às ' + date.toLocaleTimeString('pt-BR', {
        hour: '2-digit',
        minute: '2-digit'
      });
    },
    ago: (value) => {
      if (!value) return '';

      const inputDate = new Date(value);
      const now = new Date();

      // Verificar se a data é válida
      if (isNaN(inputDate.getTime())) return '';

      // Calcular diferença em milissegundos
      const diffMs = now.getTime() - inputDate.getTime();
      const diffDays = Math.floor(diffMs / (1000 * 60 * 60 * 24));
      const diffHours = Math.floor(diffMs / (1000 * 60 * 60));

      // Verificar se é hoje (mesmo dia)
      const isToday = inputDate.toDateString() === now.toDateString();
      if (isToday) return 'hoje';

      // Verificar se é ontem
      const yesterday = new Date(now);
      yesterday.setDate(yesterday.getDate() - 1);
      const isYesterday = inputDate.toDateString() === yesterday.toDateString();
      if (isYesterday) return 'ontem';

      // Verificar se é nos últimos 7 dias
      if (diffDays < 7) return 'esta semana';

      // A menos de 30 dias
      if (diffDays <= 30) return `${diffDays} dias atrás`;

      // Calcular meses
      const diffMonths = Math.floor(diffDays / 30);

      // Mais de 30 dias e menos de 1 ano
      if (diffMonths < 12) {
        return diffMonths === 1 ? '1 mês atrás' : `${diffMonths} meses atrás`;
      }

      // Calcular anos
      const diffYears = Math.floor(diffDays / 365);

      // Mais de 1 ano e menos de 2
      if (diffYears === 1) return '1 ano atrás';

      // 2 anos ou mais
      return `${diffYears} anos atrás`;
    }
  },

  price: {
    brl: (cents) => {
      if (!cents) return cents;
      cents = parseInt(cents)
      const numericValue = `${cents}`?.replace(/\D/g, "");
      const integerPart = numericValue.slice(0, -2)?.replace(/^0+/, "") || "0";
      const decimalPart = numericValue.slice(-2);

      const formattedInteger = integerPart.replace(
        /\B(?=(\d{3})+(?!\d))/g,
        "."
      );

      return `${formattedInteger},${decimalPart}`;
    },
  },

  interval: {
    adjective: (interval) => {
      return {
        week: "Semanal",
        month: "Mensal",
        bimonthly: "Bimestral",
        quarterly: "Trimestral",
        semiannual: "Semestral",
        year: "Anual",
        lifetime: "Vitalício",
      }[interval];
    },
    noun: (interval) => {
      return {
        week: "Semana",
        month: "Mês",
        bimonthly: "Bimestre",
        quarterly: "Trimestre",
        semiannual: "Semestre",
        year: "Ano",
        lifetime: "Vitalício",
      }[interval];
    },
  },


  payment: {
    chargeStatus(status) {
      return {
        'paid': 'Pago',
        'pending': 'Pendente',
        'processing': 'Processando',
        'canceled': 'Cancelado',
        'refunded': 'Reembolsado',
        'default': 'Desconhecido'
      }[status || 'default'];
    },
    subscriptionStatus(status) {
      return {
        'active': 'Ativa',
        'canceled': 'Cancelada',
        'expired': 'Expirada',
        'unknown': 'Pendente'
      }[status || 'unknown'];
    }
  },
};

export default Parser;
